import { ScrollReveal } from "@components/motion/Transitioned"
import { ContentBlock } from "eddev/blocks"

export default {
  "group/wysiwyg": (props: ContentBlock) => {
    return (
      <ScrollReveal>
        <div
          className="rich-text-group"
          data-transition="children/fade"
          dangerouslySetInnerHTML={{ __html: props.innerHTML as string }}
        />
      </ScrollReveal>
    )
  },
}
